import router from "@/router";
import store from "@/store";
import systemMessages from "@/assets/text.json"
import { h } from "vue";

export async function signUpAsync(user){
  try{
    const url = `${process.env.VUE_APP_API_URL}Auth/SignUp`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(user)
    });
    return response.json();
  }catch(e){
    throw new Error(systemMessages.modalMessages[0].message, {cause: systemMessages.modalMessages[0].caption})
  }
}

export async function loginAsync(user){
  try{
    const url = `${process.env.VUE_APP_API_URL}Auth/Login`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(user)
    });
    var data = await response.json();
    return data;
  }catch(e){
    throw new Error(systemMessages.modalMessages[0].message, {cause: systemMessages.modalMessages[0].caption})
  }
}

export async function resentVerificationLinkAsync(body){
  try{
    const url = `${process.env.VUE_APP_API_URL}Auth/ResendVerificationLink`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    });
    var data = await response.json();
    return data;
  }catch(e){
    throw new Error(systemMessages.modalMessages[0].message, {cause: systemMessages.modalMessages[0].caption})
  }
}

export async function verifyEmailAsync(userId,token){
  try{
    const url = `${process.env.VUE_APP_API_URL}Auth/VerifyEmail/${encodeURIComponent(userId)}/${encodeURIComponent(token)}`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    });
    var data = await response.json();
    return data;
  }catch(e){
    throw new Error(systemMessages.modalMessages[0].message, {cause: systemMessages.modalMessages[0].caption})
  }

}

export async function sendPasswordResetLink(user){
  try{
    const url = `${process.env.VUE_APP_API_URL}Auth/SendResetLink`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(user)
    });
    var data = await response.json();
    return data;
    }catch(e){
    throw new Error(systemMessages.modalMessages[0].message, {cause: systemMessages.modalMessages[0].caption})
  }
}


export async function resetPasswordAsync(user){
  try{
    const url = `${process.env.VUE_APP_API_URL}Auth/ResetPassword`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(user)
    });
    var data = await response.json();
    return data;
  }catch(e){
    throw new Error(systemMessages.modalMessages[0].message, {cause: systemMessages.modalMessages[0].caption})
  }
}

//------------------- AUTHORIZATION CHECKS ---------------------//

export async function CheckAuthorizeStatusAsync(response){

  //if unauthorized (e.g. invalid token or not logged in)
  if(response.status === 401){
    var data = await response.json();
    store.dispatch('auth/logout');
    router.push({path:'/login',
                query:{
                  message: data.message
                }
    });
  }
  
}

export async function CheckAuthorizeStatusAsyncAndCloseModal(response, closeModal){

  //if unauthorized (e.g. invalid token or not logged in)
  if(response.status === 401){
    closeModal();
    var data = await response.json();
    store.dispatch('auth/logout');
    router.push({path:'/login', 
                query:{
                  "message": data.message
                }
    });
    
  }
  
}

//----------------------------------------------------------//

export function NewCheckAuthorizeStatus(status, data){

  //if unauthorized (e.g. invalid token or not logged in)
  if(status === 401){
    store.dispatch('auth/logout');
    router.push('/login')
    throw new Error(data.message, {cause: data.caption})
  }
  
}

export async function CheckSubscriptionStatusAsync(response){
  
  if(response.status === 400){
   
    var data = await response.json();
    if(data.requireSubscription == true){
      let user = JSON.parse(localStorage.getItem("user")); 
   
        // No matching role - redirect safely
        if (user.roles?.includes("JobSeeker")) {
          router.push('/billing?hasExpired=expired');
        }
         if (user.roles?.includes("Employer")) {
          router.push('/enterprise/billing?hasExpired=expired');
        } 
    }
  }
}

export async function CheckSubscriptionStatusAndCloseModalAsync(response, closeModal){
  
  if(response.status === 400){
   
    var data = await response.json();
    if(data.requireSubscription == true){
      let user = JSON.parse(localStorage.getItem("user")); 
   
        //Close modal when subscription is required
        closeModal();

        // No matching role - redirect safely
        if (user.roles?.includes("JobSeeker")) {
          router.push('/billing?hasExpired=expired');
        }
         if (user.roles?.includes("Employer")) {
          router.push('/enterprise/billing?hasExpired=expired');
        } 
    }
  }
}



//Check if user can access resources
export function canAccess(routeName) {

  let authUser = store.getters['auth/getAuthenticatedUser'];
  // Resolve the route by name. `resolved.matched` contains the matched route records.
  const resolved = router.resolve({ name: routeName })

  // Use the most-specific matched record (last entry) so child route meta is respected.
  const matched = resolved?.matched || []
  if (!matched.length) return false // route not found

  const record = matched[matched.length - 1]
  const meta = record.meta || {}

  // Read token from localStorage (used by guards elsewhere in the app).
  const token = localStorage.getItem('token')

  // Prefer the `authUser` from the Vuex store. Handle both plain objects and Vue refs.
  let user = (authUser && authUser.value !== undefined) ? authUser.value : authUser;
  if (!user) {
    try {
      const stored = localStorage.getItem('user')
      user = stored ? JSON.parse(stored) : null
    } catch (e) {
      user = null
    }
  }

  // If the route requires authentication and there's no token, deny access.
  if (meta.requiresAuth && !token) {
    return false
  }

  // If the route specifies allowed roles, check the user's role in multiple possible shapes:
  //  - user.roles: an array of role strings
  //  - user.userType: a single role stored under `userType` (used in signup)
  //  - user.role: another common single-role field
  if (meta.roles) {
    let hasRole = false
    if (Array.isArray(user?.roles)) {
      hasRole = user.roles.some(role => meta.roles.includes(role))
    } else if (user?.userType) {
      hasRole = meta.roles.includes(user.userType)
    } else if (user?.role) {
      hasRole = meta.roles.includes(user.role)
    }
    if (!hasRole) return false
  }

  // No checks failed — allow access.
  return true
}

export async function getPublicProfileAsync(handle){
  try{
    const url = `${process.env.VUE_APP_API_URL}Auth/${handle}`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    });
    return response.json();
  }catch(e){
    throw new Error(systemMessages.modalMessages[0].message, {cause: systemMessages.modalMessages[0].caption})
  }
}

export async function getPublicProfileJobListingsAsync(handle,page){
try{

const url = `${process.env.VUE_APP_API_URL}Auth/JobListings/${handle}?pageNumber=${page}`;
// Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Authorization': token != null? `Bearer ${token}` : ``
    }
  });
  return response.json();
}catch(e){
  throw new Error(e.message);
}
}

export async function getProfileForEditAsync(){
const url = `${process.env.VUE_APP_API_URL}Auth/ProfileForEdit`;
 // Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':`Bearer ${token}`
    }
  });
 let checkAuthorizeStatusResponse = response.clone();
 await CheckAuthorizeStatusAsync(checkAuthorizeStatusResponse);
  return response.json();

}
